import { render } from "./QuizAttemptsPanel.vue?vue&type=template&id=1ddb67e2"
import script from "./QuizAttemptsPanel.vue?vue&type=script&lang=js"
export * from "./QuizAttemptsPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__